<template>
  <a-card :bordered="false">
    <a-form layout="inline" style="margin-bottom: 2vh;">
      <a-row :gutter="24">
        <a-col :md="6" :sm="24">
          <a-form-item label="终端名称">
            <a-input placeholder="" class="hundred"/>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="文件名">
            <a-input placeholder="" class="hundred"/>
          </a-form-item>
        </a-col>
        <a-col :md="10" :sm="24">
          <a-form-item label="更新时间">
            <a-range-picker @change="onChange"/>
          </a-form-item>
        </a-col>
        <a-col :md="2" :sm="24">
          <a-button type="primary">查询</a-button>
        </a-col>
      </a-row>
      <a-row :gutter="24">
      </a-row>
    </a-form>

    <a-table
      :rowSelection="rowSelection"
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="page.content"
      :pagination="pagination"
      :loading="false">
      <template slot="name" slot-scope="text, record">
        <router-link to="#">{{ record.filename }}</router-link>
      </template>
      <template slot="dev" slot-scope="text, record">
        <a-row :gutter="24" v-for="item in record.devices" :key="item.id">
          <router-link to="#">{{ item.name }}</router-link>
        </a-row>
      </template>
      <template slot="result" slot-scope="text">
        <a-tag :color="text==='成功'?'green':'red'">{{ text }}</a-tag>
      </template>
    </a-table>
  </a-card>
</template>

<script>
export default {
  name: 'DeviceLog',

  data () {
    return {
      visible: {
        edit: false
      },
      columns: [
        {
          title: '文件名',
          dataIndex: 'filename',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '更新终端',
          dataIndex: 'devices',
          scopedSlots: { customRender: 'dev' }
        },
        {
          title: '更新时间',
          dataIndex: 'gmtCreate'
        },
        {
          title: '操作人',
          dataIndex: 'creatorName'
        },
        {
          title: '结果',
          dataIndex: 'result',
          scopedSlots: { customRender: 'result' }
        }
      ],
      page: {
        content: [{
          id: '1',
          filename: '2019022001.pkg',
          devices: [
            { id: '1', name: '酒店电视 2578' },
            { id: '2', name: '酒店电视 2579' },
            { id: '3', name: '酒店电视 2580' }
          ],
          gmtCreate: '2019-01-30 12:00',
          creatorName: '管理员',
          result: '成功'
        }, {
          id: '2',
          filename: '多媒体广告发布系统1007A.pkg',
          devices: [
            { id: '1', name: '众达广告Q2-001' },
            { id: '2', name: '众达广告Q2-002' },
            { id: '3', name: '众达广告Q2-003' },
            { id: '4', name: '众达广告Q2-004' }
          ],
          gmtCreate: '2019-01-02 17:13:40',
          creatorName: '管理员',
          result: '成功'
        }, {
          id: '3',
          filename: 'e30715cb3faa5c7c.pkg',
          devices: [
            { id: '1', name: '酒店电视 2579' },
            { id: '2', name: '酒店电视 2580' }
          ],
          gmtCreate: '2018-12-08 10:31:55',
          creatorName: '管理员',
          result: '失败'
        }],
        empty: false,
        first: true,
        last: true,
        number: 1,
        numberOfElements: 1,
        size: 1,
        sort: {},
        totalElements: 1,
        totalPages: 1
      },
      pagination: {
        current: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      }
    }
  },

  computed: {
    rowSelection () {
      const ctx = this
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          ctx.unitIds = selectedRowKeys
          console.log(ctx.unitIds)
        }
      }
    }
  },

  methods: {
    handleEdit (record) {
      this.visible.edit = true
    },

    handleOk () {

    },

    onChange (val) {
      console.log(val)
    }
  }
}
</script>

<style lang="less" scoped>
  .forty {
    width: 40%;
  }
  .sixty {
    width: 60%;
  }
  .hundred {
    width: 100%;
  }
</style>
